(function() {
    'use strict';

    angular
        .module('app')
        .directive('fileguide', fileguide);

    fileguide.$inject = ['$window', 'fileGuideService', 'searchService', 'gridDataService', 'loginService', '$timeout'];
    
    function fileguide($window, fileGuideService, searchService, gridDataService, loginService, $timeout) {
        // Usage:
        //     <librarybrowser></librarybrowser>
        // Creates:
        // 
        var directive = {
            scope: {
                libraryTree: "=",
                onHide: "=",
                onClose: "=",
                containerSize: "=",
                textChanged: "=",
                height: "=",
            },
            link: link,
            restrict: 'EA',
            templateUrl: 'app/fileguide/templates/fileguide.html'
        };
        return directive;

        function link(scope, element, attrs) {

            scope.fileGuideService = fileGuideService;
            scope.loginService = loginService;
            scope.inputChanged = function (query) {
                if (!query) {
                    query = "";
                    scope.treeFilter = "";
                }
                fileGuideService.filterTree(query);
            }

            scope.itemClicked = function (item) {
                $timeout(function () {
                    fileGuideService.unselectNodes(scope.fileGuideService.tree);
                    $timeout(function myfunction() {
                        item.selected = true;
                        //ignore vaults
                        $timeout(function () {
                            if (item.vaultType) {
                                return;
                            }
                            var criteria = [{
                                schemaID: 'SCHEMA_S_LIBID',
                                valueStr: "=" + item.libId,
                                startDate: "",
                                endDate: "",
                                searchOp: 0
                            }];
                            searchService.searchCriteria = (criteria === undefined) ? vm.criteria : criteria;

                            gridDataService.genericDataService = searchService;
                            //must identify the service in order to inject the correct one.
                            gridDataService.serviceIdentifier = "searchService";
                            //reset, since it's a new search
                            gridDataService.totalRecords = 0;
                        });
                        
                    });
                });               
            }
        }
    }

})();